import { render, staticRenderFns } from "./SDialogAddOrderComp.vue?vue&type=template&id=79b5c3ab&"
import script from "./SDialogAddOrderComp.vue?vue&type=script&lang=js&"
export * from "./SDialogAddOrderComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports